import type { PropsWithChildren } from 'react';
import * as React from 'react';

import classnames from 'classnames';

import './EmptyView.scss';

import Button from 'common/components/core/Button/Button';

export type EmptyViewProps = {
  id?: string;
  'data-test'?: string;
  className?: string;
  iconUrl?: string;
  description?: string | JSX.Element;
  actionButtonText?: string;
  onActionButtonClick?: () => void;
  disabled?: boolean;
  fullScreen?: boolean;
};

export default function EmptyView(props: PropsWithChildren<EmptyViewProps>) {
  const {
    id,
    iconUrl,
    description,
    onActionButtonClick,
    disabled,
    actionButtonText,
    fullScreen = false,
    className,
    children,
  } = props;
  const classNames = classnames('empty-view', className, {
    'empty-view--full-screen': fullScreen,
  });

  return (
    <div className={classNames} id={id} data-test={props['data-test']}>
      {iconUrl && <img data-test="empty-view-icon" src={iconUrl} alt="no items" className="empty-view__icon" />}

      {description && (
        <div data-test="empty-view-description" className="empty-view__description">
          {description}
        </div>
      )}

      {onActionButtonClick && (
        <Button
          id="main-action-button"
          data-test="main-action-button"
          onClick={onActionButtonClick}
          disabled={disabled}
        >
          {actionButtonText}
        </Button>
      )}

      {children && (
        <div data-test="empty-view-content" className="empty-view__content">
          {children}
        </div>
      )}
    </div>
  );
}
